import type React from "react";
import { type CSSProperties, forwardRef } from "react";
import { vars } from "../../theme/theme.css";
import {
  errorSlotClass,
  errorSlotInnerClass,
  fieldInfoContainerClass,
} from "./styles.css";

interface FieldInfoProps extends React.HTMLAttributes<HTMLParagraphElement> {
  isError?: boolean;
  isDisabled?: boolean;
}

/**
 * @deprecated Use `Field.Error` and `Field.Description` from `@base-ui/react/field` inside a `Field.Root` wrapper instead.
 * FieldInfo will be removed in a future major version.
 */
export const FieldInfo = forwardRef(function FieldInfo(
  { isError, isDisabled, children, className, ...props }: FieldInfoProps,
  ref: React.Ref<HTMLParagraphElement>,
) {
  let color: string;
  if (isError) {
    color = vars.colors.red.default;
  } else if (isDisabled) {
    color = vars.colors.neutral.light;
  } else {
    color = vars.colors.neutral.dark;
  }

  const dynamicStyles: CSSProperties = { color };
  const visible = !!children;

  return (
    <div className={errorSlotClass} data-visible={visible ? "true" : "false"}>
      <div className={errorSlotInnerClass}>
        <p
          className={`${fieldInfoContainerClass}${className ? ` ${className}` : ""}`}
          ref={ref}
          style={dynamicStyles}
          data-visible={visible ? "true" : "false"}
          {...props}
        >
          {children}
        </p>
      </div>
    </div>
  );
});

FieldInfo.displayName = "FieldInfo";
